export const SET_DRAWING_MODULE = 'SET_DRAWING_MODULE';
export const GET_DRAWING_PACKAGE = 'GET_DRAWING_PACKAGE';
